import { DataGrid } from "devextreme-react";
import {
  Column,
  ColumnChooser,
  Grouping,
  GroupPanel,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { MovementTypeColumn } from "./MovementTypeColumn";
import React from "react";
import { constructionObjectTransactionRecordDto } from "../../../dtos/transactions/constructionObjectTransactionRecordDto";

interface IProps {
  items: constructionObjectTransactionRecordDto[];
}

export const ConstructionObjectTransactionRecordTable = ({ items }: IProps) => {
  const pageSizes = [10, 25, 50, 100];

  return (
    <>
      <div className={"overflow-auto"}>
        <DataGrid
          dataSource={items}
          sorting={{ mode: "multiple" }}
          allowColumnReordering={true}
          rowAlternationEnabled={false}
          showBorders={false}
          showRowLines={true}
          allowColumnResizing={true}
          selection={{ mode: "single" }}
          loadPanel={{ enabled: true, showIndicator: true, showPane: false }}
        >
          <ColumnChooser enabled={true} />
          <GroupPanel visible={true} />
          <SearchPanel visible={true} highlightCaseSensitive={true} />
          <Grouping autoExpandAll={false} />

          <Column
            dataField="tableMovementType"
            dataType="string"
            caption={"Movement Type"}
            width={100}
            cellRender={(column: any) => {
              return <MovementTypeColumn column={column} />;
            }}
          />

          <Column
            width={150}
            dataField={"period"}
            dataType={"datetime"}
            caption={"Period"}
            sortOrder={"asc"}
            sortIndex={1}
          />
          <Column
            width={75}
            dataField={"constructionObjectId"}
            dataType="string"
          />
          <Column width={75} dataField={"amount"} dataType="number" />

          <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true} />
          <Paging defaultPageSize={10} />
        </DataGrid>
      </div>
    </>
  );
};
